/**
 * The language of the public page currently on screen, for code that lives
 * outside React (the global query-error toast in App.tsx). Portal pages set
 * it once they know the customer's language and clear it when they unmount,
 * so admin pages keep their English toast (audit D11).
 */
let active: string | null = null;

export function setActivePublicLanguage(lang: string | null): void {
  active = lang;
}

export function getActivePublicLanguage(): string | null {
  return active;
}
